const PHONE_NUMBER_LENGTH = 10;

export const formatPhoneNumber = (phoneNumber?: string) =>
  phoneNumber
    ? phoneNumber.replace(/\s/g, '').padStart(PHONE_NUMBER_LENGTH, '0').replace(/(\d{2})(?=\d)/g, '$1.')
    : '';
